import s from "./index.module.css";

export function SwitchTabs({ tabs = [], selected = '', onTabChange = () => null }) {
    return (
        <div className={s.tabsContainer}>
            {tabs.map((tab) => (
                <button
                    key={tab.id}
                    type="button"
                    onClick={() => onTabChange(tab.id)}
                    className={`${s.tab} ${selected === tab.id ? s.activeTab : ""} ${tabs.length > 1 ? s.tabFull : s.tabHalf}`}
                >
                    {tab.label}
                </button>
            ))}
        </div>
    )
}